@if (layout === 'open') {
  <rma-icon class="-mt-1" [fill]="1" [inline]="true" glyph="star" />
} @else {
  <rma-icon class="pr-1" [fill]="1" [inline]="true" glyph="star" />
}
{{ overallStars }}
